/*
 * @Description:
 * @Author: 梁平贤
 * @LastEditors: 梁平贤
 * @Date: 2019-10-15 13:40:18
 * @LastEditTime: 2019-10-21 17:36:50
 */
import component from "./src";
component.install = function(Vue) {
  Vue.component(component.name, component);
};
export default component;
